import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";

interface IErrorModal {
    open: boolean;
    onClose: () => void;
    error: string;
    title: string;
  }

  export const ErrorModal: FC<IErrorModal> = ({
    open,
    onClose,
    error,
    title,
  }) => {
    const dialogHeader = "CSM Shopfloor";
  
    const buttons = [
      {
        buttonModel: {
          content: "OK",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
            onClose();
        },
      }
    ];
  
    const firstPosition = { X: 400, Y: 200 };
  
    return (
      <DialogComponent
        width="400px"
        close={onClose}
        header={title && title.length > 0 ? title : dialogHeader}
        visible={open}
        showCloseIcon={true}
        buttons={buttons}
        position={firstPosition}
        isModal
      >
        {error}
      </DialogComponent>
    );
  };